var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_22886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06641 7.21118L12.0008 12.1012L20.9352 7.21118",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.1023V21.7473",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.61 17.1413L12.36 21.6581C12.2496 21.7185 12.1258 21.7502 12 21.7502C11.8742 21.7502 11.7504 21.7185 11.64 21.6581L3.39 17.1413C3.2722 17.0768 3.17386 16.9819 3.10526 16.8665C3.03666 16.751 3.0003 16.6193 3 16.485V7.51688C3.0003 7.3826 3.03666 7.25086 3.10526 7.13543C3.17386 7.01999 3.2722 6.92509 3.39 6.86063L11.64 2.34376C11.7504 2.28336 11.8742 2.25171 12 2.25171C12.1258 2.25171 12.2496 2.28336 12.36 2.34376L20.61 6.86063C20.7278 6.92509 20.8261 7.01999 20.8947 7.13543C20.9633 7.25086 20.9997 7.3826 21 7.51688V16.4831C21 16.6177 20.9638 16.7499 20.8952 16.8657C20.8266 16.9815 20.7281 17.0766 20.61 17.1413Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64453 4.52905L16.4983 9.37499V14.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_22886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.3052d2aa4dfcf90f1663bf0b79e2efb3.svg";
export { ForwardRef as ReactComponent };